var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    attrs: {
      "flat": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16"
  }, [_vm._v(" 메모하기 ")]), _c('vertical-form-table', _vm._b({
    scopedSlots: _vm._u([{
      key: "메모내용",
      fn: function fn() {
        return [_c('v-textarea', _vm._b({
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.content,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "content", $$v);
            },
            expression: "form.content"
          }
        }, 'v-textarea', _vm.attrs_input, false))];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false)), _c('v-layout', {
    staticClass: "mt-20 mt-lg-40",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-100px min-w-140px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.post
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("저장")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }